import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface Download {
  downloadID: string
  status: string
  progress: number
  [key: string]: any
}

interface DownloadsState {
  downloads: Download[]
}

const initialState: DownloadsState = {
  downloads: [],
}

const downloadsSlice = createSlice({
  name: 'downloads',
  initialState,
  reducers: {
    addDownload: (state, action: PayloadAction<Download>) => {
      state.downloads.unshift(action.payload)
    },
    removeDownload: (state, action: PayloadAction<Download>) => {
      state.downloads = state.downloads.filter(
        (item) => item.downloadID !== action.payload.downloadID
      )
    },
    updateProgress: {
      prepare(download: Download, progress: number) {
        return { payload: { download, progress } }
      },
      reducer(state, action: PayloadAction<{ download: Download; progress: number }>) {
        const { download, progress } = action.payload
        const item = state.downloads.find((d) => d.downloadID === download.downloadID)
        if (item) {
          item.progress = progress
        }
      },
    },
    updateStatus: {
      prepare(download: Download, status: string) {
        return { payload: { download, status } }
      },
      reducer(state, action: PayloadAction<{ download: Download; status: string }>) {
        const { download, status } = action.payload
        const item = state.downloads.find((d) => d.downloadID === download.downloadID)
        if (item) {
          item.status = status
        }
      },
    },
    updateDownload: {
      prepare(download: Download, update: Partial<Download>) {
        return { payload: { download, update } }
      },
      reducer(state, action: PayloadAction<{ download: Download; update: Partial<Download> }>) {
        const { download, update } = action.payload
        const item = state.downloads.find((d) => d.downloadID === download.downloadID)
        if (item) {
          Object.assign(item, update)
        }
      },
    },
    removeFinished: (state) => {
      state.downloads = state.downloads.filter((item) => item.status !== 'finished')
    },
    reset: () => initialState,
  },
})

export const downloadsActions = downloadsSlice.actions
export const downloadsReducer = downloadsSlice.reducer
export default downloadsActions
